import { styled } from 'styled-components';

import _getGames from '@src/io/events_out/_getGames';
import refresh from '@src/asset/img/refresh.png';

import useSound from 'use-sound';
import lobbyRefresh from '@src/asset/sound/lobbyRefresh.wav';

const Button = styled.img`
  height: 2.7rem;
  width: 2.7rem;

  cursor: pointer;
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;

  @media only screen and (max-width: 720px) {
    width: 2rem;
    height: 2rem;
  }
`;

export default function RefreshGamesButton() {
  const [playSound] = useSound(lobbyRefresh, { volume: 0.25 });

  const onClick = () => {
    playSound();
    _getGames();
  };
  return <Button src={refresh} onClick={onClick} title='refresh' />;
}
